import { lazy } from "react";
import type { RouteConfig } from "../types";
import { ComponentSuspense } from "@/components/ui/suspense-wrapper";

const TemplatesBrowser = lazy(
  () => import("@/pages/app/admin/templates/templates-browser"),
);

export const adminTemplateRoutes: RouteConfig[] = [
  {
    path: "admin/templates",
    element: (
      <ComponentSuspense>
        <TemplatesBrowser />
      </ComponentSuspense>
    ),
    meta: {
      title: "Templates | UzaForm",
      description: "Browse and manage form and process templates",
    },
  },
];
